import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeat = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 8C6.34315 8 5 9.34315 5 11C5 12.6569 6.34315 14 8 14C9.65685 14 11 12.6569 11 11C11 9.34315 9.65685 8 8 8ZM3 11C3 8.23858 5.23858 6 8 6C10.7614 6 13 8.23858 13 11C13 13.7614 10.7614 16 8 16C5.23858 16 3 13.7614 3 11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 14C8.55228 14 9 14.4477 9 15V17H10C10.5523 17 11 17.4477 11 18C11 18.5523 10.5523 19 10 19H9V20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20V19H6C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17H7V15C7 14.4477 7.44772 14 8 14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13 8C11.3431 8 10 9.34315 10 11C10 12.6569 11.3431 14 13 14C14.6569 14 16 12.6569 16 11C16 9.34315 14.6569 8 13 8ZM8 11C8 8.23858 10.2386 6 13 6C15.7614 6 18 8.23858 18 11C18 13.7614 15.7614 16 13 16C10.2386 16 8 13.7614 8 11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.5 4C16.5 3.44772 16.9477 3 17.5 3H20C20.5523 3 21 3.44772 21 4V6.5C21 7.05228 20.5523 7.5 20 7.5C19.4477 7.5 19 7.05228 19 6.5V6.41421L16.7071 8.70711C16.3166 9.09763 15.6834 9.09763 15.2929 8.70711C14.9024 8.31658 14.9024 7.68342 15.2929 7.29289L17.5858 5H17.5C16.9477 5 16.5 4.55228 16.5 4Z",
			fill: "currentColor"
		})
	]
});
export default SvgHeat;
